export default (text: string): string | null => {
    if (!text) return null;
    if (config && config.debug) return text;
    let result = "";

    if (text.indexOf("+") === 0) { result = "+"; }
    if (text.length > 4) { result = result + "*".repeat(text.length - 4 - result.length) + text.slice(text.length - 4); } else { result = text; }
    return result;
};
